import React from 'react';
import moment from 'moment';
import { UncontrolledDropdown, DropdownToggle, DropdownMenu, DropdownItem } from 'reactstrap';

const TicketItem = ({ 
  ticket, 
  draggable, 
  providedDrag, 
  providedDrop, 
  onEdit, 
  onDuplicate, 
  onDelete, 
  isDragging 
}) => {
  const formatDate = (date) => {
    return date ? moment(date).format('MM/DD/YYYY @ hh:mm A') : 'N/A';
  };

  const formatCurrency = (price) => {
    return parseFloat(price).toLocaleString('en-US', {
      style: 'currency',
      currency: 'USD',
      minimumFractionDigits: 2
    });
  };

  const getProgressPercentage = () => {
    if (!ticket.quantity) return 0;
    const sold = ticket.sold || 0;
    return Math.min(100, (sold / ticket.quantity) * 100);
  };

  const getDateStatus = () => {
    const now = moment();
    
    // Check if we have valid startDate and endDate, otherwise use offset days
    const hasValidDates = ticket.startDate && ticket.endDate;
    
    return hasValidDates ? (() => {
      const startDateTimeString = `${ticket.startDate} ${ticket.startTime}`;
      const endDateTimeString = `${ticket.endDate} ${ticket.endTime}`;
      const startDate = moment(startDateTimeString);
      const endDate = moment(endDateTimeString);
  
      if (startDate && now.isBefore(startDate)) {
        return `Sales start on ${formatDate(startDateTimeString)}`;
      } else if (endDate && now.isAfter(endDate)) {
        return `Sales ended on ${formatDate(endDateTimeString)}`;
      } else {
        return `Sales end on ${formatDate(endDateTimeString)}`;
      }
    })() : (() => {
      const startDesc = ticket.startOffsetDays === 0 ? 'on event day' : `${ticket.startOffsetDays} days before event`;
      const endDesc = ticket.endOffsetDays === 0 ? 'on event day' : `${ticket.endOffsetDays} days after event starts`;
      
      return `Sales start ${startDesc}, end ${endDesc}`;
    })();
  };

  return (
    <div 
      {...providedDrag}
      className={`ticket-item ${isDragging ? 'dragging' : ''}`}
    >
      <div className="ticket-item-content">
        {draggable && (
          <div 
            {...providedDrop} 
            className="drag-handle"
          >
            <i className="las la-braille" />
          </div>
        )}

        <div className="ticket-info">
          <div className="ticket-header">
            <h3>{ticket.label}</h3>
            <span className="ticket-price">
              {formatCurrency(ticket.price)}
            </span>
          </div>
          
          <p className="ticket-description">
            {ticket.description}
          </p>
          
          <div className="ticket-progress">
            <div className="progress-bar">
              <div 
                className="progress-fill"
                style={{ width: `${getProgressPercentage()}%` }}
              ></div>
            </div>
            
            <div className="progress-info">
              <span>{getDateStatus()}</span>
              <span>{ticket.sold || 0} of {ticket.quantity} sold</span>
            </div>
          </div>
        </div>

        <div className="ticket-actions">
          <UncontrolledDropdown>
            <DropdownToggle className="p-7 ml-10">
              <i className="las la-ellipsis-v"></i>
            </DropdownToggle>
            <DropdownMenu right className="columnDropdown p-20">
              <DropdownItem 
                onClick={onEdit}
                className="dropdown-item"
              >
                <i className="las la-edit mr-10"></i>
                <span>Edit</span>
              </DropdownItem>
              <DropdownItem 
                onClick={onDuplicate}
                className="dropdown-item"
              >
                <i className="las la-copy mr-10"></i>
                <span>Duplicate</span>
              </DropdownItem>
              <DropdownItem 
                onClick={onDelete}
                className="dropdown-item delete"
              >
                <i className="las la-trash-alt mr-10"></i>
                <span>Delete</span>
              </DropdownItem>
            </DropdownMenu>
          </UncontrolledDropdown>
        </div>
      </div>
    </div>
  );
};

export default TicketItem;